<div [formGroup]="formGroup" *ngIf="{userCanEdit: userCanEdit$ | async} as data" class="main fade-in">
	<div class="section">
		<div class="section-title">
			<div class="title">title*</div>
		</div>
		<div class="text-input" *ngIf="data.userCanEdit">
			<input formControlName="title">
		</div>
		<div class="fake-text-input" *ngIf="!data.userCanEdit">
			{{formGroup.value.title || ''}}
		</div>
	</div>

	<div class="section" *ngIf="args.softwareRequest && args.softwareRequest.status === SoftwareRequestStatus.Rejected">
		<div class="section-title">
			<div class="title">
				rejection reason
			</div>
		</div>
		<div class="fake-text-input">
			{{args.softwareRequest.rejectionReason}}
		</div>
	</div>

	<div class="section">
		<div class="section-title">
			<div class="title">description</div>

			<div class="actions right" *ngIf="data.userCanEdit">
				<div class="toggle-group">
					<div (click)="markdownView$.next(MarkdownView.Markdown)"
						[ngClass]="{'selected': markdownView$.value === MarkdownView.Markdown}"
						class="button circle-button">
						<img src="/assets/icons/markdown.svg" class="icon-white">
					</div>
					<div (click)="markdownView$.next(MarkdownView.Split)"
						[ngClass]="{'selected': markdownView$.value === MarkdownView.Split}"
						class="button circle-button">
						<img src="/assets/icons/split_screen.svg" class="icon-white">
					</div>
					<div (click)="markdownView$.next(MarkdownView.Preview)"
						[ngClass]="{'selected': markdownView$.value === MarkdownView.Preview}"
						class="button circle-button">
						<img src="/assets/icons/document.svg" class="icon-white">
					</div>
				</div>
			</div>
		</div>

		<div class="content" *ngIf="{descriptionMarkdown: formGroup.value.description} as data">
			<div [ngSwitch]="markdownView$.value" class="markdown-container">

				<div *ngSwitchCase="MarkdownView.Markdown" class="markdown-only">
					<div class="text-input">
						<textarea *ngIf="('markdown-textarea') as inputId" [id]="inputId"
							[value]="data.descriptionMarkdown || ''" (paste)="handleMarkdownPaste($event,inputId)"
							(input)="updateMarkdown(inputId)" (drop)="onMarkdownDrop($event, inputId)"
							(dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">

                                </textarea>
					</div>
				</div>

				<div *ngSwitchCase="MarkdownView.Split" class="split">
					<textarea *ngIf="('markdown-textarea') as inputId" [id]="inputId"
						[value]="data.descriptionMarkdown || ''" (paste)="handleMarkdownPaste($event,inputId)"
						(input)="updateMarkdown(inputId)" (drop)="onMarkdownDrop($event, inputId)"
						(dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" class="column">

                            </textarea>
					<div [innerHTML]="(data.descriptionMarkdown || '') | markdown: true"
						class="column preview markdown">
					</div>
				</div>

				<div *ngSwitchCase="MarkdownView.Preview" class="preview-only">
					<div [innerHTML]="(data.descriptionMarkdown || '') | markdown: true" class="preview markdown">
					</div>
				</div>

			</div>
		</div>
	</div>
</div>